import {Component, OnInit} from '@angular/core';
import {PingServerService} from './service/ping-server.service';
import {Router} from '@angular/router';
import {environment} from '../../../environments/environment';


@Component({
  selector: 'app-server-status',
  templateUrl: './serverstatus.component.html',
  styleUrls: ['./serverstatus.component.css']
})
export class ServerstatusComponent implements OnInit {
  isServerOn: boolean;
  dcCounter;
  serveurOnCounter;

  timeLeft = environment.serverPingInterval;
  serverPingTimeout = environment.serverPingTimeout;
  serverPingXInterval = environment.serverPingXInterval;
  serverPingOnMax = environment.serverPingOnMax;

  tenSecondInterval;
  xSecondInterval;
  isTenSecondIntervalOn;

  constructor(private pingServerService: PingServerService, private router: Router) {
  }

  ngOnInit() {
    this.dcCounter = 0;
    this.serveurOnCounter = 0;
    this.pingServerService.pingServer().subscribe(data => {
        this.isServerOn = true;
      },
      error => {
        this.isServerOn = false;
      });
    this.startTenSecondTimer();

  }

  pingServer() {
    this.pingServerService.pingServer().subscribe(data => {
        this.serveurOnCounter++;
        this.isServerOn = true;
      },
      error => {
        this.dcCounter++;
        if (this.dcCounter === this.serverPingTimeout) {
          clearInterval(this.tenSecondInterval);
          window.sessionStorage.clear();
          this.router.navigateByUrl('/authentication/login');
        }
        if (!this.isTenSecondIntervalOn) {
          clearInterval(this.xSecondInterval);
          this.serveurOnCounter = 0;
          this.startTenSecondTimer();
        }
        this.isServerOn = false;
      });
  }

  startTenSecondTimer() {
    this.isTenSecondIntervalOn = true;
    console.log(environment.serverPingInterval + 's regime');
    this.tenSecondInterval = setInterval(() => {
      if (this.serveurOnCounter === this.serverPingOnMax - 1) {

        clearInterval(this.tenSecondInterval);
        this.isTenSecondIntervalOn = false;
        this.startXSecondsTimer();
      } else {
        if (this.timeLeft === 0) {
          this.pingServer();
          this.timeLeft = environment.serverPingInterval;
        } else {
          this.timeLeft--;
        }
      }

    }, 1000);
  }

  startXSecondsTimer() {
    this.isTenSecondIntervalOn = false;
    console.log(this.serverPingXInterval + 's regime');
    this.xSecondInterval = setInterval(() => {
      if (this.timeLeft === 0) {
        this.pingServer();
        this.timeLeft = this.serverPingXInterval;
      } else {
        this.timeLeft--;
      }
    }, 1000);
  }

  reset() {
    this.timeLeft = environment.serverPingInterval;
    this.serverPingXInterval = environment.serverPingXInterval;
    this.serverPingOnMax = environment.serverPingOnMax;
  }
}
